import { app } from '../../../app';
import { Controller } from './login.controller';

app.component('login', {
    controller: Controller,
    templateUrl: require('./login.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/login/login.component.js